import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=3edd628c&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=ts"
export * from "./Imprint.vue?vue&type=script&lang=ts"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=3edd628c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd628c",
  null
  
)

export default component.exports